import React from 'react';
export function Footer() {
  return <footer className="py-12 bg-zinc-950 border-t border-zinc-900 text-center" role="contentinfo" data-id="element-148">
      <div className="container mx-auto px-4" data-id="element-149">
        <p className="text-zinc-500 font-bold tracking-widest uppercase mb-4" data-id="element-150">
          by MASTER PACK: REPARACIÓN EXPRESS 🇦🇷
        </p>
        <p className="text-zinc-600 max-w-md mx-auto text-sm" data-id="element-151">
          Para el usuario de monopatín eléctrico que no puede permitirse
          depender del service para moverse cada día.
        </p>
        <nav className="mt-6" aria-label="Enlaces legales" data-id="element-152">
          <p className="text-zinc-700 text-xs" data-id="element-153">
            © {new Date().getFullYear()} Fegion. Todos los derechos reservados.
          </p>
        </nav>
      </div>
    </footer>;
}